import React, { FC } from 'react';
import RightArrow from 'assets/svg/RightArrow';

interface Props {
    expandFilter: Function;
    isGlobalFilterDisabled: boolean;
}

function FIlterSideBarUIElement({ expandFilter, isGlobalFilterDisabled }: Props) {
    return (
        <div
            className={`bg-purpleFont cursor-pointer mt-[8.5vh] mb-[8.5vh] rounded-r-lg ${
                isGlobalFilterDisabled ? 'pointer-events-none' : ''
            }`}
            onClick={() => expandFilter()}
        >
            <div className="global-filter-expand-width h-[70vh] flex items-center justify-center">
                <span>
                    <RightArrow />
                </span>
            </div>
        </div>
    );
}

export default FIlterSideBarUIElement;
